export class ElementHistoryDocument {
  public constructor(
    public id: string,
    public name: string,
    public webUrl: URL,
    public createdDateTime?: Date
  ) {}
}
